import type { createDropdownMenu } from '@melt-ui/svelte';
import { getContext, setContext } from 'svelte';
import type { Readable } from 'svelte/store';

const symbol = Symbol('context of ButtonMenu');

export function getButtonMenuContext() {
    return getContext<ButtonMenuContext>(symbol);
}

export function setButtonMenuContext(buttonMenu: ButtonMenuContext): void {
    setContext<ButtonMenuContext>(symbol, buttonMenu);
}

type ButtonMenuContext = {
    meltMenu: ReturnType<typeof createDropdownMenu>;
    isLoading: Readable<(key: string) => boolean>;
    allDisabled: Readable<boolean>;
    onClick: (actionKey: string) => void;
};
